<template>
  <div>
    <div v-if="loading" v-loading="loading" class="loading"></div>
    <div v-else>
      <div>
        <div class="ra-page--section">
          <el-row type="flex">
            <el-col
              :span="24"
              class="is-flex is-justify-between is-align-center"
            >
              <div>
                <h6>Auth X</h6>
                <p>
                  Create secure & beautiful login pages to easily authenticate
                  and onboard your users
                </p>
              </div>
              <el-button
                v-if="userCan('authx', 'app.create')"
                type="primary"
                size="medium"
                @click="createAuthX"
                >Add New</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div class="ra-page--section">
          <el-row type="flex" class="flex-wrap" :gutter="30">
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <ra-summary-card label="Total Apps" :value="apps.total" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <ra-summary-card label="Total Active apps" :value="apps.active" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <ra-summary-card
                label="Total Inactive apps"
                :value="apps.inactive"
              />
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row type="flex" class="mb-1">
            <el-col :span="24" class="is-flex is-justify-end">
              <div class="is-flex is-align-center">
                <p class="mr-1">Current view -</p>
                <el-dropdown @command="setView">
                  <el-button type="plain" size="small">
                    {{ views[view] }} <i class="ra-icon--chevron-down"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      icon="ra-icon--grid"
                      :class="{ selected: view === 'grid' }"
                      command="grid"
                      >Grid view</el-dropdown-item
                    >
                    <el-dropdown-item
                      icon="ra-icon--list"
                      :class="{ selected: view === 'list' }"
                      command="list"
                      >List view</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
          </el-row>
          <div v-if="view === 'grid'" class="ra-page--section">
            <el-row type="flex" class="flex-wrap" :gutter="40">
              <el-col
                v-for="(auth, index) in pageData"
                :key="index"
                :md="8"
                :lg="8"
              >
                <div class="ra-authx--app">
                  <application-status-change
                    :key="auth.id"
                    :show-text="false"
                    :app-status.sync="auth.status_id"
                    :app-id="auth.id"
                    :app-name="auth.name"
                    @success="loadApps"
                  />
                  <div class="app">
                    <div>
                      <p class="text-cursor" @click="viewAuthX(auth.id)">
                        {{ auth.name }}
                      </p>
                      <span>{{ auth.description }}</span>
                    </div>
                    <div v-if="userCan('authx', 'app.create')" class="actions">
                      <el-dropdown class="more" @command="command">
                        <span>
                          <i class="ra-icon--more-vertical"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            icon="ra-icon--edit-2"
                            :command="{ action: 'edit', id: auth.id }"
                          >
                            Edit</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="ra-icon--copy"
                            :command="{ action: 'duplicate', id: auth.id }"
                          >
                            Duplicate</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="24">
                <div class="is-flex is-justify-end mb-4">
                  <ra-pagination
                    v-if="dataFound"
                    :from="from"
                    :to="to"
                    :total="total"
                    :pageSize="pagination.perPage"
                    :current-page.sync="currentPage"
                  />
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-else class="ra-page--section">
            <el-row type="flex">
              <el-col :span="24">
                <ra-card :header="false">
                  <template slot="content">
                    <el-table
                      :data="pageData"
                      v-loading="loading"
                      :empty-text="noDataMessage"
                    >
                      <el-table-column prop="status_id" width="100">
                        <template slot="header">
                          <span class="ra-table--header">
                            Active
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <application-status-change
                            :key="scope.row.id"
                            :show-text="false"
                            :app-status.sync="scope.row.status_id"
                            :app-id="scope.row.id"
                            :app-name="scope.row.name"
                            @success="loadApps"
                          />
                        </template>
                      </el-table-column>

                      <el-table-column prop="name">
                        <template slot="header">
                          <span class="ra-table--header">
                            Name
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <div class="rd-stack">
                            <p
                              class="text-cursor"
                              @click="viewAuthX(scope.row.id)"
                            >
                              {{ scope.row.name }}
                            </p>
                            <span v-if="scope.row.description">{{
                              scope.row.description
                            }}</span>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="created_at">
                        <template slot="header">
                          <span class="ra-table--header">
                            Created
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <p>{{ scope.row.created_at }}</p>
                        </template>
                      </el-table-column>

                      <el-table-column prop="modified_at">
                        <template slot="header">
                          <span class="ra-table--header">
                            Updated
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <p>{{ scope.row.modified_at }}</p>
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-if="userCan('authx', 'app.create')"
                        width="80"
                      >
                        <template slot-scope="scope">
                          <el-dropdown class="more" @command="command">
                            <span>
                              <i class="ra-icon--more-vertical"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item
                                icon="ra-icon--edit-2"
                                :command="{ action: 'edit', id: scope.row.id }"
                              >
                                Edit</el-dropdown-item
                              >
                              <el-dropdown-item
                                icon="ra-icon--copy"
                                :command="{
                                  action: 'duplicate',
                                  id: scope.row.id
                                }"
                              >
                                Duplicate</el-dropdown-item
                              >
                            </el-dropdown-menu>
                          </el-dropdown>
                        </template>
                      </el-table-column>
                    </el-table>
                    <ra-pagination
                      v-if="dataFound"
                      :from="from"
                      :to="to"
                      :total="total"
                      :pageSize="pagination.perPage"
                      :current-page.sync="currentPage"
                    />
                  </template>
                </ra-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderBy } from "@/lib/utils";
import apiConstants from "@/apiConstants";
import ApplicationStatusChange from "@/components/Products/AuthX/Applications/Actions/ApplicationStatusChange";

const paging = {
  perPage: 20,
  total: 0
};

export default {
  name: "AuthX",
  components: { ApplicationStatusChange },
  data() {
    return {
      routes: [
        {
          name: "authx.index",
          label: "AuthX"
        },
        {
          name: "authx.applications",
          label: "Applications"
        }
      ],
      view: "grid",
      views: {
        grid: "Grid view",
        list: "List view"
      },
      loading: false,
      onboarding: false,
      apps: {
        total: 0,
        active: 0,
        inactive: 0
      },
      pageData: [],
      currentPage: 1,
      pagination: {
        perPage: 20,
        total: 0
      },
      noDataMessage: "You do not have any application(s)"
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    dataFound() {
      return !!this.pageData.length;
    }
  },
  mounted() {
    this.loadApps();
  },
  watch: {
    currentPage() {
      this.loadApps();
    }
  },
  methods: {
    createAuthX() {
      this.$router.push({ name: "authx.apps.create" });
    },

    setView(view) {
      this.view = view;
    },

    command(command) {
      const { action, id, name } = command;
      switch (action) {
        case "edit":
          this.editAuthX(id);
          break;
        case "duplicate":
          this.duplicateAuthX(id);
          break;
        case "delete":
          this.deleteAuthX(id, name);
          break;
      }
    },
    viewAuthX(id) {
      this.$router.push({ name: "authx.apps.overview", params: { id } });
    },
    editAuthX(id) {
      this.$router.push({ name: "authx.apps.configuration", params: { id } });
    },

    duplicateAuthX(id) {
      this.$router.push({ name: "authx.apps.create", params: { id } });
    },

    deleteAuthX(id, name) {
      this.$confirm(`Do you really want to delete, ${name} ?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          // Api call to delete goes here.
          // If call is successfully, we manually delete on the frontend to give the illusion of updated data.
          this.pageData = this.pageData.filter(authx => authx.id !== id);
          this.pagination.total = this.pageData.length;
        })
        .catch(() => {});
    },

    getPaginationParams() {
      return `page_size=${this.pagination.perPage}&page=${this.currentPage}`;
    },

    resetPagination() {
      this.pagination = { ...paging };
      this.currentPage = 1;
    },

    loadApps() {
      this.loading = true;
      const apiUrl = "apps";
      const sortBy = orderBy("id");

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: `${sortBy}&${this.getPaginationParams()}`
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;

          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            const { list, stats, pagination } = resData;
            this.pageData = list;
            this.pagination.total = resData.pagination.total_count;
            this.apps.total = pagination.total_count;
            this.apps.active = stats.active_app_count;
            this.apps.inactive = stats.inactive_app_count;
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.ra-authx--app {
  height: auto;
  width: 100%;
  padding: 15px 15px 15px 25px;
  display: flex;
  align-items: flex-start;
  background: #9e153110;
  border: 1px solid var(--ra-primary);
  border-radius: 8px;
  transition: all 0.3s ease-in;
  box-shadow: 0 0 30px 0 rgb(82 63 105 / 10%);
  margin-bottom: 30px;
  min-height: 80px;

  .app {
    margin-left: 15px;
    display: flex;
    justify-content: space-between;
    width: 100%;

    p {
      color: #140508;
      font-size: 0.85rem;
      font-weight: 500;
    }

    span {
      font-size: 0.75rem;
    }
  }

  img {
    border-radius: 100px;
    object-fit: cover;
    height: 50px;
    width: auto;
    margin-bottom: 10px;
  }

  .actions {
    display: flex;
    align-items: flex-start;

    span {
      padding: 8px;
      border-radius: 100px;
      color: #140508;
      cursor: pointer;

      i {
        color: #140508;
        font-size: 1rem;
      }

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}

.loading {
  height: 200px;
  background: #fff;
  border-radius: 10px;
}
</style>
